import './App.css';
import Header from './components/Header';
import Grid from './components/Grid';

function App() {
  return (
    <div className="App">
      <Header/>
      <Grid />
    </div>
  );
}

export default App;
